import React, {useEffect, useState} from "react";
import {CustomDatePicker, DateRangeWithModal, DateRangeWithModal2} from "../../component/datepicker";
import {convertDate, deConvertDate} from '../../util/convertDate';
export function HealthCheckupDateComponent({selectedHandler}) {

    const [checkupDate, setCheckupDate] = useState(new Date());

    function selectedDateHandler(date) {
        setCheckupDate(date);
    }

    useEffect(() => {
        selectedHandler(convertDate(checkupDate));
    }, [checkupDate])

    return (
        <CustomDatePicker startDate={checkupDate} selectedDateHandler={(date) => selectedDateHandler(date)} />
    )
}
export function HealthCheckupSearchDateComponent({selectedHandler, minDate}) {

    const [checkupDate, setCheckupDate] = useState(new Date());

    function selectedDateHandler(date) {
        setCheckupDate(date);
    }

    useEffect(() => {
        selectedHandler(convertDate(checkupDate));
    }, [checkupDate])

    return (
        <DateRangeWithModal2 startDate={checkupDate} minDate={deConvertDate(minDate)} selectedDateHandler={(date) => selectedDateHandler(date)} />
    )
}